import React               from "react";
import {Grid, makeStyles}                 from '@material-ui/core';

const useStyles = makeStyles(theme =>({
  questionContainer:{
    width: "100%",
    height:"100%",
  },
  reading: {
    width: "80%",
    margin:"10px 0 10px 0 ",
    font: '22px lato',
    letterSpacing: '0.21px',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",

    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",
 
    }, 
  },
  table: {
    width: "100%",
    font: '22px lato',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",
 
    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",

    }, 
  },
  tdTable: {
    padding: "0 1%",
    // border: '1px solid black',
  }
}));

const QuestionTable = (props) => {
  const classes = useStyles()

  return(
    <Grid container className={classes.questionContainer}>
      <p
        className={classes.reading}
      >
        4. Relaciona el tipo de narración con su definición. 
      </p>
      <br/>
      <table className={classes.table}>
        <thead>
          <th style={{width: "30%",}}><i>Tipo de narración</i></th>
          <th style={{width: "70%",}}><i>Definición</i></th>
        </thead>
        <tbody>
          <tr>
            <td className={classes.tdTable}>
              <p>
                1. Leyenda
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                a. Historia real o fantástica, hecha para entretener. Se define por sus personajes y ambientes. 
                Puede encontrarse en libros, películas, series o novelas.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p>
                2. Didáctico
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                b. Narración de corte fantástico y sobrenatural, protagonizado por dioses, semidioses y héroes. 
                No existe momento temporal en la historia. Ayuda a explicar los símbolos y las fuerzas de la naturaleza.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p>
                3. Mito
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                c. Está basada en un hecho real que se volvió fantasía. Explica o enaltece hechos inexplicables o admirables.
                Es creada en comunidades específicas y transmitidas por la tradición oral.
              </p>
            </td>
          </tr>
          <tr>
            <td className={classes.tdTable}>
              <p>
                4. Cuento
              </p>
            </td>
            <td className={classes.tdTable}>
              <p>
                d. Texto protagonizado por animales o cosas que representan virtudes o valores. 
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  )
}

export default QuestionTable;
